// extracted by mini-css-extract-plugin
module.exports = {"boxesContainer":"cs_hY","policy":"cs_bT","buttonContainer":"cs_dp","successMessage":"cs_hZ","underline":"cs_bV"};